import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

const STEPS = [
  { step: "01", nameKey: "process.s1", descKey: "process.s1d" },
  { step: "02", nameKey: "process.s2", descKey: "process.s2d" },
  { step: "03", nameKey: "process.s3", descKey: "process.s3d" },
  { step: "04", nameKey: "process.s4", descKey: "process.s4d" },
];

export default function Process() {
  const { t } = useLang();
  return (
    <section id="process" data-testid="process-section" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="04" label={t("process.tag")} />
        <SectionHeading>{t("process.heading")}</SectionHeading>
        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={0.1 + i * 0.12}>
              <div data-testid={`process-step-${i}`} className="relative border-t border-white/15 pt-8">
                <span className="absolute -top-[5px] left-0 h-2 w-2 rounded-full bg-mint" />
                <span className="font-display text-6xl font-black tracking-tight text-white/10 transition-colors duration-500 hover:text-mint/30">
                  {s.step}
                </span>
                <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-bone">{t(s.nameKey)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-fog">{t(s.descKey)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
